// Third Party
import * as React from 'react';

// Utils
import { UniquePropertyType } from '@gql';

// UI

type Props = {
  allUniquePropertyTypes: UniquePropertyType[];
  currentActiveUniquePropertyTypes: UniquePropertyType[];
  toggleUniquePropertyTypesFilter: (
    uniquePropertyType: UniquePropertyType
  ) => void;
};

export const UniquePropertyTypeSelection: React.FC<Props> = ({
  allUniquePropertyTypes,
  currentActiveUniquePropertyTypes,
  toggleUniquePropertyTypesFilter,
}) => {
  return (
    <div className="mt-4 grid gap-x-8 lg:grid-cols-2 lg:gap-x-16">
      {allUniquePropertyTypes.map((uniquePropertyType, index) => {
        return (
          <div key={index}>
            <label
              htmlFor={mapPropertyTypeToTitle(uniquePropertyType)}
              className="flex items-center justify-between font-semibold text-primary-dark hover:cursor-pointer"
            >
              {mapPropertyTypeToTitle(uniquePropertyType)}
              <input
                id={mapPropertyTypeToTitle(uniquePropertyType)}
                type="checkbox"
                className="my-2 mr-2 flex h-5 w-5 items-center border-2 border-primary-dark accent-primary-main transition duration-150 ease-in-out"
                onClick={() =>
                  toggleUniquePropertyTypesFilter(uniquePropertyType)
                }
                checked={currentActiveUniquePropertyTypes.includes(
                  uniquePropertyType
                )}
              />
            </label>
          </div>
        );
      })}
    </div>
  );
};

const mapPropertyTypeToTitle = (
  uniquePropertyType: UniquePropertyType
): string => {
  switch (uniquePropertyType) {
    case UniquePropertyType.Barn:
      return 'Barn';
    case UniquePropertyType.Boat:
      return 'Boat';
    case UniquePropertyType.Bungalow:
      return 'Bungalows';
    case UniquePropertyType.Cabin:
      return 'Cabin';
    case UniquePropertyType.Campsite:
      return 'Boat';
    case UniquePropertyType.Castle:
      return 'Castle';
    case UniquePropertyType.Cottage:
      return 'Cottage';
    case UniquePropertyType.HistoricHotel:
      return 'Historic';
    case UniquePropertyType.Houseboat:
      return 'Houseboat';
    case UniquePropertyType.Hut:
      return 'Hut';
    case UniquePropertyType.Lighthouse:
      return 'Lighthouse';
    case UniquePropertyType.NatureLodge:
      return 'Nature lodge';
    case UniquePropertyType.GlampingTent:
      return 'Tent';
    case UniquePropertyType.TinyHome:
      return 'Tiny House';
    case UniquePropertyType.Villa:
      return 'Villa';
    default:
      return '';
  }
};
